"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const DeleteOutlineOutlined_1 = __importDefault(require("@mui/icons-material/DeleteOutlineOutlined"));
const EditOutlined_1 = __importDefault(require("@mui/icons-material/EditOutlined"));
const DriveFileMoveOutlined_1 = __importDefault(require("@mui/icons-material/DriveFileMoveOutlined"));
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const components_1 = require("@alcumus/components");
const clsx_1 = __importDefault(require("clsx"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const analytics_package_1 = __importDefault(require("@alcumus/analytics-package"));
const MoveDashboardModal_1 = require("../Modals/MoveDashboardModal");
const DeleteFolderModal_1 = require("../FoldersPage/DeleteFolderModal");
const useStyles = (0, styles_1.makeStyles)({
    deleteButton: {
        color: `${components_1.StyleVariables.colors.action.critical.default}`,
        '& .MuiSvgIcon-root': {
            color: `${components_1.StyleVariables.colors.action.critical.default} !important`,
        },
    },
    kebabIcon: {
        borderRadius: 4,
        padding: 8,
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.grey2,
        },
        '&:active,&[aria-expanded="true"]': {
            backgroundColor: components_1.StyleVariables.colors.surface.selected,
            color: components_1.StyleVariables.colors.action.primary.default,
        },
    },
    paper: {
        boxShadow: `0px 2px 8px ${components_1.StyleVariables.colors.boxShadowGrey}`,
        borderRadius: '8px',
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
    },
    menuItem: {
        '& .MuiSvgIcon-root': {
            marginRight: 8,
            color: components_1.StyleVariables.colors.grey4,
        },
    },
});
const ReportOptionsColumn = ({ showEdit, showMove, showDelete, editFunction, className, row, t, tReady, enableDelete, currentFolderId, }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const [, setMoveDashboardModalVisible] = (0, recoil_1.useRecoilState)(MoveDashboardModal_1.moveDashboardModalVisibleState);
    const [, setMoveDashboardId] = (0, recoil_1.useRecoilState)(MoveDashboardModal_1.moveDashboardModalDashboardId);
    const [, setMoveDashboardName] = (0, recoil_1.useRecoilState)(MoveDashboardModal_1.moveDashboardModalDashboardName);
    const [, setMoveFolderId] = (0, recoil_1.useRecoilState)(MoveDashboardModal_1.moveDashboardModalFolderId);
    const [, setMoveFolderName] = (0, recoil_1.useRecoilState)(MoveDashboardModal_1.moveDashboardModalFolderName);
    const [, setDeleteFolderModalVisible] = (0, recoil_1.useRecoilState)(DeleteFolderModal_1.deleteFolderModalVisibleState);
    const [, setDeleteCurrentFolderId] = (0, recoil_1.useRecoilState)(DeleteFolderModal_1.deleteFolderModalCurrentFolderId);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        analytics_package_1.default.getInstance().trackWithCategory('Reports', 'Opened a report menu');
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleEdit = () => {
        if (editFunction) {
            editFunction();
            analytics_package_1.default.getInstance().trackWithCategory('Reports', 'Clicked Rename Dashboard');
        }
        setAnchorEl(null);
    };
    const handleDelete = () => {
        setDeleteCurrentFolderId(row?.id || currentFolderId || -1);
        setDeleteFolderModalVisible(true);
        setAnchorEl(null);
        analytics_package_1.default.getInstance().trackWithCategory('Reports', 'Deleted a report');
    };
    const handleMove = () => {
        setMoveDashboardId(row?.id.toString() || '');
        setMoveDashboardName(row?.name || '');
        setMoveFolderId(row?.folderId || -1);
        setMoveFolderName(row?.folder || '');
        setMoveDashboardModalVisible(true);
        setAnchorEl(null);
        analytics_package_1.default.getInstance().trackWithCategory('Reports', 'Moved a report');
    };
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
            react_1.default.createElement(core_1.IconButton, { "data-testid": "reportMenu", "aria-haspopup": "true", "aria-expanded": !!open, onClick: handleClick, className: (0, clsx_1.default)(classes.kebabIcon, className), disableRipple: true },
                react_1.default.createElement(MoreVert_1.default, null)),
            react_1.default.createElement(core_1.Menu, { "data-testid": "reportMenu", open: open, anchorEl: anchorEl, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': t('reportMenu', { ns: 'AriaLabels' }),
                    classes: {
                        root: classes.menuItem,
                    },
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, getContentAnchorEl: null, PopoverClasses: {
                    paper: classes.paper,
                } },
                !showEdit && (react_1.default.createElement(core_1.MenuItem, { onClick: handleEdit, disabled: !enableDelete, "data-testid": "Rename" },
                    react_1.default.createElement(EditOutlined_1.default, null),
                    t('rename', { ns: 'ReportOptions' }))),
                !!showMove && (react_1.default.createElement(core_1.MenuItem, { onClick: handleMove, "data-testid": "Move" },
                    react_1.default.createElement(DriveFileMoveOutlined_1.default, null),
                    t('move', { ns: 'ReportOptions' }))),
                !!showDelete && enableDelete && (react_1.default.createElement(core_1.MenuItem, { onClick: handleDelete, disabled: !enableDelete, className: classes.deleteButton, "data-testid": "Delete" },
                    react_1.default.createElement(DeleteOutlineOutlined_1.default, null),
                    t('delete', { ns: 'ReportOptions' })))))));
};
exports.default = (0, react_i18next_1.withTranslation)(['ReportOptions', 'AriaLabels'])(ReportOptionsColumn);
